import {
  GetOrganizationChartDepartments200ResponseInner,
  GetOrganizationChartEmployees200ResponseInner,
  GetOrganizationChartRoles200ResponseInner,
  ParseOrganizationChartForWorkflow200Response,
} from '@src/api/generated/user-api'
import apiSchema from '@src/test/generated/api-schema.json'

export const mockGetOrganizationChartDepartmentsResponse: GetOrganizationChartDepartments200ResponseInner[] =
  apiSchema.paths[
    '/organizations/{organizationId}/workflows/organization_charts/departments'
  ].get.responses[200].content['application/json'].examples['base'].value

export const mockGetOrganizationChartEmployeesResponse: GetOrganizationChartEmployees200ResponseInner[] =
  apiSchema.paths[
    '/organizations/{organizationId}/workflows/organization_charts/employees'
  ].get.responses[200].content['application/json'].examples['base'].value

export const mockGetOrganizationChartRolesResponse: GetOrganizationChartRoles200ResponseInner[] =
  apiSchema.paths[
    '/organizations/{organizationId}/workflows/organization_charts/roles'
  ].get.responses[200].content['application/json'].examples['base'].value

export const mockParseOrganizationChartForWorkflowResponse: ParseOrganizationChartForWorkflow200Response =
  apiSchema.paths['/workflows/parse_organization_chart'].post.responses[200]
    .content['application/json'].examples['base'].value

// Do Not Remove this line ===@import mock ===
